import React, { useState } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { testimonials as fallbackTestimonials } from "../mock";
import { useContent, renderHighlightedTitle } from "../lib/useContent";

const Testimonials = () => {
  const [i, setI] = useState(0);
  const { field } = useContent("home");
  const pretitle = field("testimonials", "pretitle", "Le voci di Sanluri");
  const headline = field("testimonials", "headline", "Parole di chi vive il centro.");
  const highlightTerms = field("testimonials", "highlight_terms", ["vive"]);
  const description = field("testimonials", "description", "Commercianti, clienti e ospiti raccontano cosa significa vivere e visitare il cuore di Sanluri.");
  const itemsRaw = field("testimonials", "items", null);
  const testimonials = Array.isArray(itemsRaw) && itemsRaw.length
    ? itemsRaw.filter((t) => t.visible !== false)
    : fallbackTestimonials;

  if (testimonials.length === 0) return null;
  const t = testimonials[i % testimonials.length];

  const prev = () => setI((v) => (v - 1 + testimonials.length) % testimonials.length);
  const next = () => setI((v) => (v + 1) % testimonials.length);

  return (
    <section className="py-24 lg:py-32 bg-[#F0FAF3]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            {pretitle !== "" && <div className="text-xs uppercase tracking-[0.22em] text-stone-500 mb-4">{pretitle}</div>}
            <h2 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight text-stone-950">
              {renderHighlightedTitle(headline, highlightTerms)}
            </h2>
            {description !== "" && <p className="mt-6 text-stone-600 text-lg max-w-md">{description}</p>}
            <div className="flex items-center gap-3 mt-10">
              <button onClick={prev} className="w-12 h-12 rounded-full bg-white hover:bg-stone-950 hover:text-white flex items-center justify-center border border-stone-200 transition-colors" aria-label="Precedente">
                <ChevronLeft className="w-4 h-4" />
              </button>
              <button onClick={next} className="w-12 h-12 rounded-full bg-white hover:bg-stone-950 hover:text-white flex items-center justify-center border border-stone-200 transition-colors" aria-label="Successivo">
                <ChevronRight className="w-4 h-4" />
              </button>
              <div className="text-sm text-stone-500 ml-3 tabular-nums">
                {String(i + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative bg-white rounded-3xl p-8 md:p-14 card-shadow">
              <Quote className="w-12 h-12 text-[#12964A] mb-6" />
              <p className="font-display text-2xl md:text-3xl leading-[1.35] text-stone-900">
                {t.quote}
              </p>
              <div className="mt-10 pt-6 border-t border-stone-100 flex items-center justify-between">
                <div>
                  <div className="font-display text-xl text-stone-950">{t.name}</div>
                  <div className="text-sm text-stone-500">{t.role}</div>
                </div>
                <div className="flex gap-1.5">
                  {testimonials.map((tItem, idx) => (
                    <button
                      key={tItem.name + idx}
                      onClick={() => setI(idx)}
                      className={`h-1.5 rounded-full transition-all ${idx === i ? "w-8 bg-[#12964A]" : "w-4 bg-stone-200"}`}
                      aria-label={`Vai al testimonial ${idx + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
